import { Link } from "react-router-dom";
import Seo from "../lib/Seo";
import useReveal from "../lib/useReveal";
import { Arrow } from "../components/Icons";

export default function OurStory() {
  useReveal();
  return (
    <>
      <Seo
        title="Our Story | Dialed In"
        description="Golf found Jason Brown at seventeen, when he badly needed something to hold onto. More than twenty years later, Dialed In is the brand he wishes had existed for him."
      />
      <section className="page-head" data-testid="our-story-page">
        <div className="wrap">
          <div className="label rv rv-up">Our story</div>
          <h1 className="disp page-h rv rv-up">I'm building the brand I wish <span className="g">had existed for me.</span></h1>
        </div>
      </section>

      <section className="sec" data-testid="story-founder">
        <div className="wrap">
          <div className="founder-grid">
            <div>
              <div className="founder-photo rv rv-up">
                <img src="/images/founder.jpg" alt="Jason Brown, founder of Dialed In" />
              </div>
              <div className="rv rv-up" style={{ marginTop: 22 }}>
                <span className="founder-sig">Jason Brown<br /><span style={{ color: "var(--cream-45)" }}>Founder, Dialed In</span></span>
              </div>
            </div>
            <div className="founder-letter rv rv-up">
              <p>Golf found me at seventeen, at a point in my life when I badly needed something to hold onto.</p>
              <p>I was terrible at it. I hated plenty of it. <span className="hl">I kept coming back anyway.</span></p>
              <p>More than twenty years later, I understand why.</p>
              <p>Golf gave me somewhere to put my attention, somewhere to compete, somewhere to connect, somewhere to disappear into for a while, somewhere I could feel like myself again, even before I understood why I didn't always feel that way elsewhere.</p>
              <p>Since then, I've spent years trying to understand stress, pressure, ADHD, the brain, the body and the things people carry without always knowing how much they affect them. Through business, through life, through my own head.</p>
              <p><span className="hl">Dialed In is where all of that meets golf.</span></p>
              <p>Not as a personal project. As a real company. A real product system. A real brand for golfers who know the game gives them more than a score.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sec sec-2" data-testid="story-mission">
        <div className="wrap">
          <div className="label rv rv-up">The mission</div>
          <h2 className="disp sec-h rv rv-up">Golf gives people something <span className="g">worth protecting.</span></h2>
          <div className="body-copy rv rv-up" style={{ maxWidth: 640, marginTop: "4vh" }}>
            <p>Not just the score, but the escape, the connection, the walk, the competition, the few hours where the rest of life gets quieter.</p>
            <p>Dialed In is building products, research and a community around the moments that affect the golfer before, during and after the round — <strong>Prepare, Reset, Sustain and Recover.</strong></p>
            <p>A golf wellbeing brand built around what actually affects the round long before the swing begins.</p>
          </div>
        </div>
      </section>

      <section className="sec" data-testid="story-nod">
        <div className="wrap" style={{ textAlign: "center", maxWidth: 780 }}>
          <div className="label rv rv-up" style={{ justifyContent: "center" }}>The nod</div>
          <h2 className="disp sec-h rv rv-up" style={{ margin: "3.5vh auto 0" }}>Not attention. <span className="g">Recognition.</span></h2>
          <div className="verse rv rv-up" style={{ margin: "5vh auto 0", maxWidth: 560 }}>
            <p>One day, two golfers will see the Dialed In logo. One of them will give the other a small nod.</p>
            <p>Nothing dramatic. Nothing needs explaining. Just:</p>
            <p><strong>I get it. I know why you play. I know those few hours matter. I know there may be more behind your round than the scorecard shows.</strong></p>
            <p>That's what this brand has to earn.</p>
          </div>
          <div className="rv rv-up" style={{ marginTop: "6vh" }}>
            <Link className="cta" to="/#join" data-testid="story-join-cta">Join Dialed In <Arrow /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
